<!--====================================
=            APEXCHARTSAREA            =
=====================================-->

<template>

  <div id="chartArea"></div>
</template>


<script>
export default{
  name:'apex-chart-area',
    mounted() {
              /*-----echart1-----*/
      var options = {
        chart: {
          height: 300,
          type: "line",
          stacked: false,
          toolbar: {
            enabled: false
          }, 
          dropShadow: {
            enabled: true,
            opacity: 0.1,
          },
        },
        colors: ["#004c4c", "#66b2b2", 'rgba(231,238,237, 0.5)'],
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: "smooth",
          width: [3, 3, 0],
          dashArray: [0, 4],
          lineCap: "round"
        },    
        grid: {
          padding: {
            left: 0,
            right: 0
          },
          strokeDashArray: 3
        },
        markers: {
          size: 0,
          hover: {
            size: 0
          }
        },
        series: [{
          name: "Total Orders",
          type: 'line',
          data: [0, 45, 30, 75, 15, 94, 40, 115, 30, 105, 65, 110]

        }, {
          name: "Total Sales",
          type: 'line',
          data: [0, 60, 20, 130, 75, 130, 75, 140, 64, 130, 85, 120]
        }, {
          name: "",
          type: 'area',
          data: [0, 105, 70, 175, 85, 154, 90, 185, 120, 145, 185, 130]
        }],
        xaxis: {
          type: "month",
          categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
          axisBorder: {
            show: false,
            color: 'rgba(119, 119, 142, 0.08)',
          },
          labels: {
            style: {
              color: '#8492a6',
              fontSize: '12px',
            },
          },
        },
        yaxis: {
          labels: {
            style: {
              color: '#8492a6',
              fontSize: '12px',
            },
          },
          axisBorder: {
            show: false,
            color: 'rgba(119, 119, 142, 0.08)',
          },
        },
        fill: {
          gradient: {
            inverseColors: false,
            shade: 'light',
            type: "vertical",
            opacityFrom: 0.85,
            opacityTo: 0.55,
            stops: [0, 100, 100, 100]
          }
        },
        tooltip: {
         
          theme:'dark'
        },
        legend: {
          position: "top",
          show: true
        }
      }
      var chart = new ApexCharts(document.querySelector("#chartArea"), options);
      chart.render();

    },
}
</script>

<!--====  End of APEXCHARTSAREA  ====-->
